import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Anesthesiologist icon
 *
 * @category Medical
 */
const Anesthesiologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.973 12.328a.62.62 0 0 1 .572.36.56.56 0 0 1-.135.636L23.518 17h3.455c.342 0 .619.261.619.584 0 1.239-4.725.583-5.567.583a.62.62 0 0 1-.572-.36.56.56 0 0 1 .135-.636l3.892-3.675h-3.455c-.342 0-.619-.261-.619-.584 0-1.239 4.725-.583 5.567-.583M21.3 7.02c.236 0 .449.142.54.36.29.703-1.06 1.569-1.466 1.975h.926c.322 0 .584.262.584.584 0 1.026-2.319.584-2.92.584a.58.58 0 0 1-.54-.36c-.29-.704 1.06-1.57 1.466-1.976h-.926a.584.584 0 0 1-.584-.584c0-1.026 2.319-.583 2.92-.583m-2.486 21.336c0-.17-.064-.35-.106-.488-.254-.753-.668-1.463-1.103-2.13-.137-.213-.286-.436-.36-.68-.074-.243-.085-.53.053-.752.54-.87 1.728-.594 1.537-2.025-.063-.499-.307-.965-.54-1.41L11.837 8.687c-.127-.244-.265-.541-.148-.795.149-.308.626-.414.679-.753.042-.276-.255-.499-.53-.51-.276-.01-.53.15-.764.287-.732.424-1.495.806-2.28 1.124-.148.064-.307.117-.455.074-.149-.042-.255-.17-.35-.297a8.7 8.7 0 0 1-1.167-2.163c-.095-.254-.18-.551-.074-.805.127-.34.52-.488.806-.7s.488-.7.19-.912c-.2-.148-.476-.042-.699.053-1.07.498-2.12 1.05-3.138 1.643-.244.138-.52.35-.488.637.053.381.615.424.975.265.36-.16.764-.393 1.103-.212.17.084.276.265.371.424.382.668.742 1.357 1.071 2.046.095.19.18.403.138.615-.043.19-.191.329-.34.445-.858.658-2.056.86-2.746 1.697-.095.116-.19.275-.137.424.053.17.275.233.445.212s.34-.117.52-.149c.37-.063.742.128.996.403.255.276.403.626.551.965 1.718 3.902 3.881 7.592 5.81 11.388.213.413.425.837.764 1.155.34.318.795.541 1.251.467.52-.096 1.082-.668 1.644-.552.562.117.742.87.933 1.326.222.53.943 2.799 1.866 2.28.159-.085.201-.244.19-.425zm-4.962-3.785c-.594-.647-1.113-2.036-1.633-2.895-.434-.816-1.007-1.527.085-2.004.604-.307 1.04-.88.732-1.102-.647-.467-1.771.784-2.333.042-.244-.657.763-.997 1.135-1.41.561-.605-.064-.997-.934-.573-1.335.668-1.791-.445-.583-1.081.467-.308.817-.647.552-.997-.18-.212-.764-.095-1.22.138-.392.18-.72.318-.943.148-.52-.55-.923-1.643-1.357-2.364-.435-.859-.849-1.495-.838-1.781-.064-.36 1.537-.997 2.142-1.357.54-.191 1.569-1.05 1.908-.753.721 1.325 5.906 11.143 7.252 13.72.191.477-.54.52-1.675 1.22-1.007.487-1.664.975-2.226 1.07l-.075-.021z"
        />
      </svg>
    );
  }
);

Anesthesiologist.displayName = 'Anesthesiologist';

export { Anesthesiologist };
